// @flow
import { RouterReducer } from "../_router/RouterReducer";
import { ModularUIReducer } from "../_modularui/ModularUIReducer";
import { I18nReducer } from "../_i18n/I18nReducer";

import ModalsReducer from "./ModalsReducer";
import AuthReducer from "./AuthReducer";
import ErrorReducer from "./ErrorReducer";
import ModelCatalogReducer from "./ModelCatalogReducer";
import NotificationReducer from "./NotificationReducer";
import ProgressIndicatorReducer from "./ProgressIndicatorReducer";
import PreferencesReducer from "./PreferencesReducer";

import type { Reducer } from "redux";
import type {
  ReduxAction,
  ProgressIndicatorState,
  PreferencesState,
  NotificationState,
  ModalsState,
  ErrorState,
  AuthState,
  ModelCatalogState,
} from "../types";
import type { RouterState } from "../_router/types";
import type { ModularUIState } from "../_modularui/types";
import type { I18nState } from "../_i18n/types";

type Reducers = {
  auth: Reducer<AuthState, ReduxAction>,
  error: Reducer<ErrorState, ReduxAction>,
  i18n: Reducer<I18nState, ReduxAction>,
  modals: Reducer<ModalsState, ReduxAction>,
  modelcatalog: Reducer<ModelCatalogState, ReduxAction>,
  modularui: Reducer<ModularUIState, ReduxAction>,
  notification: Reducer<NotificationState, ReduxAction>,
  preferences: Reducer<PreferencesState, ReduxAction>,
  progressindicator: Reducer<ProgressIndicatorState, ReduxAction>,
  router: Reducer<RouterState, ReduxAction>,
};

/**
 */
export const createReducer = (): Reducers => ({
  preferences: PreferencesReducer,
  router: RouterReducer,
  modularui: ModularUIReducer,
  i18n: I18nReducer,
  auth: AuthReducer,
  error: ErrorReducer,
  modals: ModalsReducer,
  modelcatalog: ModelCatalogReducer,
  notification: NotificationReducer,
  progressindicator: ProgressIndicatorReducer,
});
